import DeferredDrawerLink from '../../drawerlink/DeferredDrawerLink';
import { getSignalConfig } from '../configs/signalConfigMap';
import { NormalizedSignal, signalQuery, signalUrl } from '../services/signals';
import { SignalCollectors } from '../types';

interface SignalDrawerProps {
  signalId: string;
  collector: SignalCollectors;
  name?: string;
  preloadedSignal?: NormalizedSignal;
}

const SignalDrawer = ({ signalId, name, collector, preloadedSignal }: SignalDrawerProps) => {
  const url = signalUrl(signalId);
  const config = getSignalConfig(collector);

  return (
    <DeferredDrawerLink
      id={signalId}
      value={name ?? signalId}
      content={config.drawer(collector, config.title)}
      query={signalQuery(signalId) as any}
      link={config.issue !== null ? url : undefined}
      preloadedData={preloadedSignal}
    />
  );
};

export default SignalDrawer;
